import React from 'react';
import AgentConversation from '../agents/shared/AgentConversation';
import { dataContentProfilerSpec } from './spec';

const DataContentProfilerConversation: React.FC = () => (
  <AgentConversation spec={dataContentProfilerSpec} />
);

export default DataContentProfilerConversation;
